import { AppBar, Container, Toolbar, Button } from '@mui/material'
import { StorageOutlined as StorageIcon, AssessmentOutlined as StatusIcon, ImportExportOutlined as ImportIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

const AnonymizerNav = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const path = location.pathname
  const activeTab = path.endsWith('/status')
    ? 'status'
    : path.endsWith('/import')
      ? 'import'
      : 'fieldConfig'

  const tabSx = (active: boolean) => ({
    ml: 1,
    fontWeight: active ? 700 : 400,
    borderBottom: active ? '2px solid' : 'none',
    borderRadius: 0,
  })

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        top: 0,
        mb: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Container maxWidth="xl" disableGutters>
        <Toolbar disableGutters variant="dense">
          <Button
            color="inherit"
            startIcon={<StorageIcon />}
            onClick={() => navigate('/anonymizer')}
            sx={{ ...tabSx(activeTab === 'fieldConfig'), ml: 2 }}
          >
            {t('anonymizer.toolName')}
          </Button>
          <Button
            color="inherit"
            startIcon={<StatusIcon />}
            onClick={() => navigate('/anonymizer/status')}
            sx={tabSx(activeTab === 'status')}
          >
            {t('anonymizer.status.tabName')}
          </Button>
          <Button
            color="inherit"
            startIcon={<ImportIcon />}
            onClick={() => navigate('/anonymizer/import')}
            sx={tabSx(activeTab === 'import')}
          >
            {t('anonymizer.import.tabName')}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default AnonymizerNav
